import React, { useContext, useMemo } from "react";
import { ArrowLeft, ArrowRight, Person, Schedule, SupervisorAccount } from "@mui/icons-material";
import { DocumentDetailContext } from "../../contexts/DocumentDetailContext";
import { CustomTooltip } from "components/CustomTooltip/CustomTooltip";
import * as msg from "utils/constants/messages";
import { ConvertUtcToLocal } from "commonFunctions/commonFunctions";

const FileInformation = () => {

    const { _baseClassName, data = {}, getDocumentDetailData, updateDocumentData, setLoader } = useContext(DocumentDetailContext);

    const activeUsersList = useMemo(() => {
        return (data?.Active_Users?.user_details || []).map(user => user.first_name);
    }, [data]);

    const navigateToParentDocument = async (docId) => {
        setLoader(prevState => ({
            ...prevState,
            fullLoader: true,
            miniLoader: true
        }));
        let childData = await getDocumentDetailData(docId);
        updateDocumentData({...childData});
    }

    return <div className={`${_baseClassName}-file-info`}>
        <div className={`file-info-wrapper`}>
            {activeUsersList?.length && <div className='file-lock-icon'>
                <CustomTooltip title={"Opened by: " + activeUsersList} placement="top-start">
                    {
                        data?.Active_Users?.status == "active" ? <SupervisorAccount className="blue-icon" /> :
                            <>
                                <Schedule className="red-icon" />
                                <Person className="red-icon_1" />
                            </>
                    }
                </CustomTooltip>
            </div> || null}
            <div className="file-name">
                <div className={`file-name-title ${data?.Active_Users?.status == "active" ? "blue-icon" : ( data?.Active_Users?.status == "stuck" ? "red-icon" : "")}`}>{data?.Name || ""}</div>
                <div className="grey-txt" style={{ fontSize: "13px", color: "var(--text-primary)" }}>
                    <span style={{ textDecoration: "none", cursor: "auto", marginRight: "2px" }}>{data?.ID}</span>
                    {data?.Entity_Details?.parentDocId && " split from "}
                    {data?.Entity_Details?.parentDocId && <span onClick={() => navigateToParentDocument(data?.Entity_Details?.parentDocId)} style={{marginLeft: "2px"}}>{" " + data?.Entity_Details?.parentDocId}</span>}
                    {data?.Staff_Name && ` (Last Edited : ${ConvertUtcToLocal(data?.Last_Updated_Date + " " + data?.Last_Updated_Time + " UTC", "MM/DD, hh:mm A")} by ${data?.Staff_Name})`}
                </div>
            </div>
        </div>
    </div>

}

export default FileInformation;